import React from "react";
import {Link} from "react-router-dom";

export default class Page extends React.Component {

    // componentDidMount() {
    //     setTimeout(() => $('[title]').on('click',
    //         (e) => $(e.currentTarget).tooltip('hide')
    //     ).tooltip(), 100);
    // }

    render() {
        return (
            <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">
                        {this.props.back && <Link to={this.props.back} className="me-2" title={t.commonBack}><em className="fa-solid fa-caret-left"></em></Link>}
                        {T(this.props.title)}
                    </h1>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        {Array.isArray(this.props.actions) ?
                            this.props.actions?.map((a, i) => <div key={i} className="btn-group me-2">{a}</div>)
                            : this.props.actions}
                        {this.props.submitForm && <span onClick={(e) => this.props.submitForm().current.submit(e)} className="btn btn-sm btn-primary ms-2" title={t.commonSend}>
                            <i className="fa-solid fa-save"></i> {t.commonSave}
                        </span>}
                    </div>
                </div>
                {this.props.children}
            </>
        );
    }
}